export const SYNC_STORE_NAME = 'web-sync-store';
export const CRYPTO_STORE_NAME = 'crypto-store';
export const CLIENT_MAX_LISTENERS = 50;
export const VERIFICATION_METHODS = ['m.sas.v1'];
export const DEFAULT_HOMESERVER = 'matrix.org';
export const CONFIG_FILE = 'config.json';
export const WELL_KNOWN_CLIENT_PATH = '/.well-known/matrix/client';
export const SPEC_VERSIONS_PATH = '/_matrix/client/versions';
export const AUTHENTICATED_MEDIA_SPEC_VERSION = 'v1.11';
export const AUTHENTICATED_MEDIA_UNSTABLE_FEATURE = 'org.matrix.msc3916.stable';
